import service from "../util/http";
import bxService from "../util/bxzh";
import store from "@/store";

// 质量咨询列表
export const seekList = data => {
  return service({
    url: "/manage/quality/list",
    method: "post",
    data
  });
};

// 上传质量咨询单回复接口
export const seekReply = data => {
  return service({
    url: "/manage/quality/reply",
    method: "post",
    data
  });
};
// 咨询单状态修改
export const seekStatus = data => {
  return service({
    url: "/manage/quality/status",
    method: "post",
    data
  });
};
// 咨询单上传附件接口
export const seekUpload = data => {
  return service({
    url: "/manage/quality/upload",
    method: "post",
    data
  });
};
// // 预审索赔单-有详情数据
// export const preClimantList = data => {
//   return service({
//     url: "/manage/claim/list/preapproval",
//     method: "post",
//     data
//   });
// };

// 预审索赔单-无详情数据
export const preClimantList = data => {
  return service({
    url: "/manage/claim/list/preapprovalOptimize",
    method: "post",
    data
  });
};

// 预审索赔单-无详情数据
export const getClimantDetail = data => {
  return service({
    url: `/manage/claim/preapprovalDetailOptimize/${data}`,
    method: "post"
  });
};

// 预审索赔单编辑
export const preClimantEdit = data => {
  return service({
    url: "/manage/claim/edit",
    method: "post",
    data
  });
};
// 索赔单列表
export const climantList = data => {
  return service({
    url: "/manage/claim/list",
    method: "post",
    data
  });
};
// 索赔单导出
export const climantExport = data => {
  return service({
    url: "/manage/claim/export",
    method: "post",
    responseType: "blob",
    data
  });
};
// KD索赔单导出
export const kdclimantExport = data => {
  return service({
    url: "/manage/kdClaim/export",
    method: "post",
    responseType: "blob",
    data
  });
};
// 索赔单审核
export const climantAudit = data => {
  return service({
    url: "/manage/claim/audit",
    method: "post",
    data
  });
};
// 索赔单预审
export const preClimantAudit = data => {
  return service({
    url: "/manage/claim/preapproval",
    method: "post",
    data
  });
};
// 预授权审核
export const auditPreAuthorizationApi = data => {
  return service({
    url: "/manage/claim/auditPreAuthorization",
    method: "post",
    data
  });
};

// 预授权审核
export const auditPreAuthorizationChangeApi = data => {
  return service({
    url: "/manage/claim/auditPreAuthorizationChange",
    method: "post",
    data
  });
};


// 订单列表
export const orderList = data => {
  return service({
    url: "/manage/order/list",
    method: "post",
    data
  });
};
// 导出订单
export const orderExport = data => {
  return service({
    url: "/manage/order/export",
    method: "post",
    responseType: "blob",
    data
  });
};
// 订单发运接口
export const orderShip = data => {
  return service({
    url: "/manage/order/dispatch",
    method: "post",
    data
  });
};
// 配件订单审核接口
export const orderAudit = data => {
  return service({
    url: "/manage/order/audit",
    method: "post",
    data
  });
};

// 咨询列表导出
export const seekExport = data => {
  return service({
    url: "/manage/quality/export",
    method: "post",
    responseType: "blob",
    data
  });
};

// 预设数据列表
export const presetList = data => {
  return service({
    url: "/manage/preset/list",
    method: "post",
    data
  });
};
// kd预设数据列表
export const kdpresetList = data => {
  return service({
    url: "/manage/kdPreset/list",
    method: "post",
    data
  });
};

// 预设数据新增
export const presetAdd = data => {
  return service({
    url: "/manage/preset/add",
    method: "post",
    data
  });
};

// 预设数据编辑
export const presetEdit = data => {
  return service({
    url: "/manage/preset/update",
    method: "post",
    data
  });
};
// 预设数据新增
export const kdpresetAdd = data => {
  return service({
    url: "/manage/kdPreset/add",
    method: "post",
    data
  });
};

// 预设数据编辑
export const kdpresetEdit = data => {
  return service({
    url: "/manage/kdPreset/update",
    method: "post",
    data
  });
};

// 改变状态
export const changeStatus = data => {
  return service({
    url: "/manage/preset/changeStatus",
    method: "post",
    data
  });
};
// 改变状态
export const kdchangeStatus = data => {
  return service({
    url: "/manage/kdPreset/changeStatus",
    method: "post",
    data
  });
};

// 获取预设数据
export const getPreset = data => {
  return service({
    url: "/manage/claim/getPreset",
    method: "post",
    data
  });
};

// 导出预设数据
export const presetExport = data => {
  return service({
    url: "/manage/preset/export",
    method: "post",
    responseType: "blob",
    data
  });
};

// 导出预设数据
export const kdpresetExport = data => {
  return service({
    url: "/manage/kdPreset/export",
    method: "post",
    responseType: "blob",
    data
  });
};

// 活动支持列表
export const kdactivitySupportList = data => {
  return service({
    url: "/manage/activitySupport/list",
    method: "post",
    data
  });
};

// 活动支持新增
export const kdactivitySupportAdd = data => {
  return service({
    url: "/manage/activitySupport/add",
    method: "post",
    data
  });
};

// 活动支持编辑
export const kdactivitySupportEdit = data => {
  return service({
    url: "/manage/activitySupport/update",
    method: "post",
    data
  });
};

// 活动支持启用/作废
export const kdactivitySupportChangeStatus = data => {
  return service({
    url: "/manage/activitySupport/changeStatus",
    method: "post",
    data
  });
};

// 活动支持导出
export const kdactivitySupportExport = data => {
  return service({
    url: "/manage/activitySupport/export",
    method: "post",
    responseType: "blob",
    data
  });
};

// 活动支持删除
export const kdactivitySupportDelete = data => {
  return service({
    url: "/manage/activitySupport/delete",
    method: "post",
    data
  });
};

// 获取大区国家树形数据
export const getAreaCountryTree = data => {
  return service({
    url: "/manage/activitySupport/areaCountryTree",
    method: "post",
    data
  });
};

// 活动支持分配国家
export const activitySupportAssignCountry = data => {
  return service({
    url: "/manage/activitySupport/assignCountry",
    method: "post",
    data
  });
};

// 获取活动支持适用国家
export const kdactivitySupportGetCountries = data => {
  return service({
    url: "/manage/activitySupport/getCountries",
    method: "post",
    data
  });
};

// 活动索赔列表
export const activityClaimList = data => {
  return service({
    url: "/manage/activityClaim/list",
    method: "post",
    data
  });
};

// 活动索赔详情
export const activityClaimDetail = data => {
  return service({
    url: "/manage/activityClaim/detail",
    method: "post",
    data
  });
};

// 活动索赔审核
export const activityClaimAudit = data => {
  return service({
    url: "/manage/activityClaim/audit",
    method: "post",
    data
  });
};

// 活动索赔修改状态（审核通过、审核驳回、结算）
export const activityClaimUpdateStatus = data => {
  return service({
    url: "/manage/activityClaim/updateStatus",
    method: "post",
    data
  });
};

// 活动索赔-批量更新车辆信息（车型）
export const activityClaimUpdateVehicles = data => {
  return service({
    url: "/manage/activityClaim/updateVehicles",
    method: "post",
    data
  });
};
// 活动索赔导出
export const activityClaimExport = data => {
  return service({
    url: "/manage/activityClaim/export",
    method: "post",
    responseType: "blob",
    data
  });
};

// 预授权设置列表
export const activityPreAuthorizationList = data => {
  return service({
    url: "/manage/preAuthorization/list",
    method: "post",
    data
  });
};

// 预授权设置新增
export const activityPreAuthorizationAdd = data => {
  return service({
    url: "/manage/preAuthorization/add",
    method: "post",
    data
  });
};

// 预授权设置编辑
export const activityPreAuthorizationEdit = data => {
  return service({
    url: "/manage/preAuthorization/update",
    method: "post",
    data
  });
};

// 预授权设置下载导入模板
export const getPreAuthorizationTemplate = data => {
  return service({
    url: "/manage/preAuthorization/template",
    method: "post",
    responseType: "blob",
    data
  });
};

// 预授权设置删除
export const activityPreAuthorizationDelete = data => {
  return service({
    url: "/manage/preAuthorization/delete",
    method: "post",
    data
  });
};

// 预授权设置导出
export const activityPreAuthorizationExport = data => {
  return service({
    url: "/manage/preAuthorization/export",
    method: "post",
    responseType: "blob",
    data
  });
};

// 预授权设置批量导入
export const activityPreAuthorizationImport = data => {
  return service({
    url: "/manage/preAuthorization/import",
    method: "post",
    data
  });
};

// 获取ECP数据
export const getECPData = data => {
  return bxService({
    url: "/api/claim/part",
    method: "post",
    data
  });
};

// 根据vin获取ECP数据
export const getECPDataByVIN = data => {
  return bxService({
    url: "/api/claim/vin",
    method: "post",
    data
  });
};

// 预审索赔单
export const preAuditClaimant = data => {
  return service({
    url: "/manage/claim/preapproval",
    method: "post",
    data
  });
};
// kd预审索赔单
export const kdpreAuditClaimant = data => {
  return service({
    url: "/manage/kdClaimMange/preapproval",
    method: "post",
    data
  });
};


// 正审索赔单
export const auditClaimant = data => {
  return service({
    url: "/manage/claim/formalReview",
    method: "post",
    data
  });
};

// 责任判定索赔单
export const responsibilityClaimant = data => {
  return service({
    url: "/manage/claim/determineResponsibility",
    method: "post",
    data
  });
};

// 加签索赔单
export const countersignClaimant = data => {
  return service({
    url: "/manage/claim/countersign",
    method: "post",
    data
  });
};

// 责任判定列表
export const responsibilitylist = data => {
  return service({
    url: "/manage/claim/responsibilityList",
    method: "post",
    data
  });
};

// 责任确认列表
export const confirmList = data => {
  return service({
    url: "/manage/claim/confirmList",
    method: "post",
    data
  });
};

// 责任确认索赔单
export const confirmResponsibility = data => {
  return service({
    url: "/manage/claim/confirmResponsibility",
    method: "post",
    data
  });
};

// 责任确认列表
export const fillSecondList = data => {
  return service({
    url: "/manage/claim/fillSecondList",
    method: "post",
    data
  });
};


// 填写金额
export const fillAmount = data => {
  return service({
    url: "/manage/claim/fillAmount",
    method: "post",
    data
  });
};

// 责任确认索赔单
export const confirmAmount = data => {
  return service({
    url: "/manage/claim/confirmAmount",
    method: "post",
    data
  });
};
// 二培金额编辑
export const confirmAmountEdit = data => {
  return service({
    url: "/manage/claim/confirmAmountEdit",
    method: "post",
    data
  });
};
// kd责任确认索赔单
export const kdconfirmAmount = data => {
  return service({
    url: "/manage/kdClaim/confirmAmount",
    method: "post",
    data
  });
};

// 批量确认金额
export const batchConfirmAmount = data => {
  return service({
    url: "/manage/claimRateMaintenanceController/confirmAmountList",
    method: "post",
    data
  });
};
//kd-批量确认金额
export const kdbatchConfirmAmount = data => {
  return service({
    url: "/manage/kdClaim/confirmAmountList",
    method: "post",
    data
  });
};

// 结算列表
export const settlementList = data => {
  return service({
    url: "/manage/claim/settlementList",
    method: "post",
    data
  });
};

// 索赔统计导出
export const claimStatisticsExport = data => {
  return service({
    url: "/manage/claim/claimStatistics/export",
    method: "post",
    responseType: "blob",
    data
  });
};
// 结算明细列表
export const settlementDetailList = data => {
  return service({
    url: "/manage/claim/settlementDetail",
    method: "post",
    data
  });
};

// 索赔单统计
export const claimStatisticsApi = data => {
  return service({
    url: "/manage/claim/claimStatistics",
    method: "post",
    data
  });
};

// 结算明细列表
export const kdsettlementDetailList = data => {
  return service({
    url: "/manage/kdClaim/settlementDetail",
    method: "post",
    data
  });
};

// 质保时间设置列表
export const warrantyTimeList = data => {
  return service({
    url: "/manage/warrantyTimeConfig/list",
    method: "post",
    data
  });
};

// 质保时间设置保存
export const warrantyTimeSave = data => {
  return service({
    url: "/manage/warrantyTimeConfig/save",
    method: "post",
    data
  });
};

// 根据国家名称从EPC查询车型列表
export const getModelsByCountry = data => {
  return service({
    url: "/manage/warrantyTimeConfig/modelsByCountry",
    method: "post",
    data
  });
};
// 质保时间设置删除
export const warrantyTimeDelete = data => {
  return service({
    url: "/manage/warrantyTimeConfig/delete",
    method: "post",
    data
  });
};

// 质保时间检查
export const warrantyTimeCheck = data => {
  return service({
    url: "/manage/warrantyTimeConfig/checkWarranty",
    method: "post",
    data
  });
};

// 根据索赔单ID检查质保时间
export const checkWarrantyTimeByClaimId = data => {
  return service({
    url: "/manage/warrantyTimeConfig/checkWarrantyByClaimId",
    method: "post",
    data
  });
};

// kd批量结算
export const kdbachSettlement = data => {
  return service({
    url: "/manage/kdClaim/bachSettlement",
    method: "post",
    data
  });
};

// 单个结算索赔单
export const settlementOne = data => {
  return service({
    url: "/manage/claim/settlementOne",
    method: "post",
    data
  });
};

// 结算索赔单
export const settlement = data => {
  return service({
    url: "/manage/claim/settlement",
    method: "post",
    data
  });
};
// kd结算索赔单
export const
  kdsettlement = data => {
  return service({
    url: "/manage/kdClaim/settlement",
    method: "post",
    data
  });
};
// kd结算明细结算
export const
  kdsettlementIds = data => {
    return service({
      url: "/manage/kdClaim/settlementIds",
      method: "post",
      data
    });
  };

// 历史记录
export const auditHistoryList = data => {
  return service({
    url: "/manage/claim/auditHistoryList",
    method: "post",
    data
  });
};

// 结算导出
export const settlementExport = data => {
  return service({
    url: "/manage/claim/settlementExport",
    method: "post",
    responseType: "blob",
    data
  });
};
// kd-结算导出
export const kdsettlementExport = data => {
  return service({
    url: "/manage/kdClaim/settlementExport",
    method: "post",
    responseType: "blob",
    data
  });
};

// 消息列表
export const messageList = data => {
  return service({
    url: "/manage/claim/messageList",
    method: "post",
    data
  });
};

// 获取未读消息
export const getNotReadMessageApi = data => {
  return service({
    url: "/manage/claim/notRead",
    method: "post",
    data
  });
};

// 已读
export const messageReading = async data => {
  return service({
    url: "/manage/claim/messageReading",
    method: "post",
    data
  }).then(async res => {
    const res2 = await getNotReadMessageApi();
    if (res2.status === "0") {
      store.state.messageCount = res2.data.length;
    }
    return res;
  });
};

// 删除
export const messageDelete = async data => {
  return service({
    url: "/manage/claim/messageDelete",
    method: "post",
    data
  }).then(async res => {
    const res2 = await getNotReadMessageApi();
    if (res2.status === "0") {
      store.state.messageCount = res2.data.length;
    }
    return res;
  });
};

// 获取首页统计数据
export const homeDataList = data => {
  return service({
    url: "/manage/homePage/homeDataList",
    method: "post",
    data
  });
};

// 获取 二赔金额   外部责任编辑  查看
export const gysPriceFillOutdataList = data => {
  return service({
    url: "/manage/claimRateMaintenanceController/sapList",
    method: "post",
    data
  });
};

// 确认 二赔金额   外部责任 编辑确认
export const postDetermineEdit = data => {
  return service({
    url: "/manage/gysPriceFillOut/insertOrUpdateGYSTwoPrice",
    method: "post",
    data
  });
};

// 历史记录

export const getHistoryList = data => {
  return service({
    url: "manage/claim/historyRepairLook",
    method: "post",
    data
  });
};

// 责任判定历史记录
export const getHistoryResponsibilityListApi = data => {
  return service({
    url:
      "/manage/claimRateMaintenanceController/selectResponsibilityPartHistoryList",
    method: "post",
    data
  });
};

// 编辑后获取新的责任判定列表
export const getResponsibilityListApi = data => {
  return service({
    url: "/manage/claimRateMaintenanceController/selectResponsibilityPart",
    method: "post",
    data
  });
};
// 责任判定历史记录
export const kdgetHistoryResponsibilityListApi = data => {
  return service({
    url:
      "/manage/kdClaim/selectResponsibilityPartHistoryList",
    method: "post",
    data
  });
};

// 编辑后获取新的责任判定列表
export const kdgetResponsibilityListApi = data => {
  return service({
    url: "/manage/kdClaim/selectResponsibilityPart",
    method: "post",
    data
  });
};

// 编辑二赔金额
export const updateSecondCompensationApi = data => {
  return service({
    url:
      "/manage/claimRateMaintenanceController/calculateSecondPriceByParamUpdate",
    method: "post",
    data
  });
};
// kd-编辑二赔金额
export const kdupdateSecondCompensationApi = data => {
  return service({
    url:
      "/manage/kdClaim/calculateSecondPriceByParamUpdate",
    method: "post",
    data
  });
};

// 编辑二赔金额历史记录
export const secondCompensationHistoryListApi = data => {
  return service({
    url:
      "/manage/claimRateMaintenanceController/selectResponsibilityPartSecondList",
    method: "post",
    data
  });
};
// 编辑kd二赔金额历史记录
export const kdsecondCompensationHistoryListApi = data => {
  return service({
    url:
      "/manage/kdClaim/selectResponsibilityPartSecondList",
    method: "post",
    data
  });
};

// 成本价维护导出
export const costPriceMaintenanceExport = data => {
  return service({
    url: "/manage/claimRateMaintenanceController/costPriceExport",
    method: "post",
    responseType: "blob",
    data
  });
};
// kd-成本价维护导出
export const kdcostPriceMaintenanceExport = data => {
  return service({
    url: "/manage/kdClaim/costPriceExport",
    method: "post",
    responseType: "blob",
    data
  });
};

// 三包索赔单导出
export const threeGuaranteesExportApi = data => {
  return service({
    url: "/manage/claimRateMaintenanceController/threeGuaranteesExport",
    method: "post",
    responseType: "blob",
    data
  });
};
// 三包索赔单导出
export const kdthreeGuaranteesExportApi = data => {
  return service({
    url: "/manage/kdClaim/threeGuaranteesExport",
    method: "post",
    responseType: "blob",
    data
  });
};

// 三包索赔打印
export const threeGuaranteesPrintApi = data => {
  return service({
    url: "/manage/claimRateMaintenanceController/threeGuaranteesPrint",
    method: "post",
    data
  });
};

// 批量责任确定
export const batchResponsibilityConfirm = data => {
  return service({
    url: "/manage/claim/zrqdBatchConfirmation",
    method: "post",
    data
  });
};
// kd-批量责任确定
export const kdbatchResponsibilityConfirm = data => {
  return service({
    url: "/manage/kdClaim/zrqdBatchConfirmation",
    method: "post",
    data
  });
};

// 驳回（正审）撤回
export const formalAuditRejectRevocationApi = id => {
  return service({
    url: `/manage/claim/revocation/${id}`,
    method: "post"
  });
};

// 预审-索赔单导出
export const pretrialClimantExport = data => {
  return service({
    url: "/manage/claimRateMaintenanceController/pretrialExport",
    method: "post",
    responseType: "blob",
    data
  });
};
// kd预审-索赔单导出
export const kdpretrialClimantExport = data => {
  return service({
    url: "/manage/kdClaimMange/pretrialExport",
    method: "post",
    responseType: "blob",
    data
  });
};

// 正审-索赔单导出
export const trialClimantExport = data => {
  return service({
    url: "/manage/claimRateMaintenanceController/trialExport",
    method: "post",
    responseType: "blob",
    data
  });
};

// 责任确认-索赔单导出
export const responsibilityConfirmClimantExport = data => {
  return service({
    url: "/manage/claimRateMaintenanceController/responsibilityConfirmExport",
    method: "post",
    responseType: "blob",
    data
  });
};
// kd责任确认-索赔单导出
export const kdresponsibilityConfirmClimantExport = data => {
  return service({
    url: "/manage/kdClaim/responsibilityConfirmExport",
    method: "post",
    responseType: "blob",
    data
  });
};

// 二赔金额确认-索赔单导出
export const secondConfirmClimantExport = data => {
  return service({
    url: "/manage/claimRateMaintenanceController/secondConfirmExport",
    method: "post",
    responseType: "blob",
    data
  });
};
// kd-二赔金额确认-索赔单导出
export const kdsecondConfirmClimantExport = data => {
  return service({
    url: "/manage/kdClaim/secondConfirmExport",
    method: "post",
    responseType: "blob",
    data
  });
};
// kd-索赔单管理预审列表
export const kdPreClimantList = data => {
  return service({
    url: "/manage/kdClaimMange/list/preapprovalOptimize",
    method: "post",
    data
  });
};
// kd预审索赔单-详细数据
export const kdgetClimantDetail = data => {
  return service({
    url: `/manage/kdClaimMange/preapprovalDetailOptimize/${data}`,
    method: "post"
  });
};
// kd预审索赔单-详细数据
export const kdgetClimantDetail1 = data => {
  return service({
    url: `/manage/kdClaim/preapprovalDetailOptimize/${data}`,
    method: "post"
  });
};
// 责任判定列表
export const kdresponsibilitylist = data => {
  return service({
    url: "/manage/claim/responsibilityList",
    method: "post",
    data
  });
};

// 责任确认列表
export const kdconfirmList = data => {
  return service({
    url: "/manage/kdClaim/confirmList",
    method: "post",
    data
  });
};

// 责任确认索赔单
export const kdconfirmResponsibility = data => {
  return service({
    url: "/manage/kdClaim/confirmResponsibility",
    method: "post",
    data
  });
};

// 责任确认列表
export const kdfillSecondList = data => {
  return service({
    url: "/manage/kdClaim/fillSecondList",
    method: "post",
    data
  });
};

// kd索赔历史列表查询
export const kdclaimHistoryList = data => {
  return service({
    url: `/manage/kdClaim/claimHistoryList`,
    method: "post"
  });
};
// 查询历史审核记录
export const kdAuditHistoryList = data => {
  return service({
    url: `/manage/kdClaim/auditHistoryList`,
    method: "post",
    data
  });
};
// kd索赔-结算列表
export const kdsettlementList = data => {
  return service({
    url: "/manage/kdClaim/settlementList",
    method: "post",
    data
  });
};

